import { render, staticRenderFns } from "./ResumeTemp5.vue?vue&type=template&id=648c084a&scoped=true&"
import script from "./ResumeTemp5.vue?vue&type=script&lang=js&"
export * from "./ResumeTemp5.vue?vue&type=script&lang=js&"
import style0 from "./ResumeTemp5.vue?vue&type=style&index=0&id=648c084a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648c084a",
  null
  
)

export default component.exports